import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Link from 'UIKit/Link'
import Text from 'UIKit/Text'
import useIsMounted from 'hooks/useIsMounted'
import { useIsomorphicEffect } from 'hooks/useIsomorphicEffect'
import { useRouter } from 'hooks/useRouter'
import { useCallback } from 'react'
import styled from 'styled-components'

interface UserMenuDropdownItemProps extends BoxProps {
  Icon: React.ReactNode
  content: string
  linkTo: string
  onClick?: () => void
  onDismiss?: () => void
  id?: string
}

const MenuItemContent = ({ content, Icon }) => {
  return (
    <Flex alignItems="center">
      <Box mr="10px">{Icon}</Box>
      <Text fontSize={['12px', '14px']} fontWeight={700}>
        {content}
      </Text>
    </Flex>
  )
}

const UserMenuDropdownItem: React.FC<UserMenuDropdownItemProps> = ({
  linkTo,
  onClick,
  onDismiss,
  Icon,
  content,
  className,
  id,
}) => {
  const route = useRouter()
  const isMounted = useIsMounted()

  useIsomorphicEffect(() => {
    if (isMounted()) {
      onDismiss()
    }
  }, [route])

  const handleCloseDropdown = useCallback(
    (handle: () => void) => {
      return () => {
        if (handle) handle()
        if (onDismiss) onDismiss()
      }
    },
    [onDismiss],
  )

  return (
    <StyledItemWrapper id={id} className={className}>
      {linkTo ? (
        <Link disabledDefaultStyle href={linkTo} width="inherit">
          <MenuItemContent content={content} Icon={Icon} />
        </Link>
      ) : (
        <Box onClick={handleCloseDropdown(onClick)} width="inherit">
          <MenuItemContent content={content} Icon={Icon} />
        </Box>
      )}
    </StyledItemWrapper>
  )
}

const StyledItemWrapper = styled(Flex)`
  align-items: center;

  padding: 7.5px 5px;
  margin: 5px auto;
  width: 100%;
  transition: ${({ theme }) => theme.transitions.fast};
`

export default UserMenuDropdownItem
